import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import {styled} from '@mui/system';

import ProgressSpinner from '../atoms/ProgressSpinner';
import CoAuthors from '../molecule/CoAuthors';
import Organizations from '../molecule/Organizations';
import Countries from '../molecule/Countries';
import States from '../molecule/States';
import Cities from '../molecule/Cities';
import Journals from '../molecule/Journals';
import PublicationList from '../molecule/PublicationList';
import GrantList from '../molecule/GrantList';
import NounPhrases from '../molecule/NounPhrases';
import OrcidIds from '../molecule/OrcidIds';


const StyledDetails = styled(Grid)({
     marginTop: 20
});


class ProfileDetails extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        if(this.props.profile){

            let publications = this.props.profile.publications;
            if (publications){
                publications = publications.sort(function(first, second) {
                    return second.pub_year - first.pub_year;
                });
            }

            return (
                <StyledDetails container spacing={5} data-bt="profile_details">
                    <Grid size={4}>
                        {this.props.profile.co_profiles && this.props.profile.co_profiles.length > 0 && <CoAuthors co_authors={this.props.profile.co_profiles} match_details={this.props.profile.co_profiles_match_details} title="Co-Profile"/>}
                        {this.props.includeCoAuthorNames && this.props.profile.co_name_codes && this.props.profile.co_name_codes.length > 0 && <CoAuthors co_authors={this.props.profile.co_name_codes} match_details={this.props.profile.co_name_codes_match_details} title="Co-Author name"/>}
                        {this.props.profile.organizations && this.props.profile.organizations.length > 0 && <Organizations organizations={this.props.profile.organizations} match_details={this.props.profile.organizations_match_details}/>}
                        {this.props.profile.journals && this.props.profile.journals.length > 0 && <Journals journals={this.props.profile.journals} match_details={this.props.profile.journals_match_details}/>}
                        {this.props.profile.cities && this.props.profile.cities.length > 0 && <Cities cities={this.props.profile.cities} match_details={this.props.profile.cities_match_details}/>}
                        {this.props.profile.states && this.props.profile.states.length > 0 && <States states={this.props.profile.states} match_details={this.props.profile.states_match_details}/>}
                        {this.props.profile.countries && this.props.profile.countries.length > 0 && <Countries countries={this.props.profile.countries} match_details={this.props.profile.countries_match_details}/>}
                        {this.props.profile.orcid_ids && this.props.profile.orcid_ids.length > 0 && <OrcidIds orcid_ids={this.props.profile.orcid_ids} match_details={this.props.profile.orcid_ids_match_details}/>}
                    </Grid>
                    <Grid size={3}>
                       <PublicationList publications={publications}/>
                    </Grid>
                    <Grid size={3}>
                        <GrantList grants={this.props.profile.grants}/>
                    </Grid>
                    <Grid size={2}>
                        <NounPhrases noun_phrases={this.props.profile.noun_phrases} match_details={this.props.profile.noun_phrases_match_details}/>
                    </Grid>
                </StyledDetails>
            );
        }
        return (
            <Grid container data-bt="profile_details">
                <Grid size={12}>
                    <ProgressSpinner />
                </Grid>
            </Grid>
        );
    }

}

ProfileDetails.propTypes = {
    profile: PropTypes.object,
    includeCoAuthorNames: PropTypes.bool
};

export default ProfileDetails;
